export const profileRole = {
    "admin": [
        "admin", 
        "admin-dealership",
        "admin-branch",
        "admin-brand"
    ],
    "seller": [
        "seller"
    ],
    "agent": [
        "agent"
    ]
};

export const roleRestrictedRoutes = {
    "admin": [
        "my_account",
        "my_buys"
    ],
    "seller": [
        "sellers",
        "my_buys",
        "documentation"
    ],
    "agent": [
        "dashboard",
        "sellers",
        "my_schedules"
    ]
};